module.exports = __webpack_public_path__ + "static/img/exit.b6c0ae49.svg";